/**
 * 👪 **보호자 화면 어른 확인 — 이 탭에서 잠깐만 기억한다** (2026-10-10).
 *
 * 예전엔 통과를 전혀 기억하지 않았다 — 보호자가 굿즈샵·안내를 보고 **뒤로 돌아올 때마다** 곱셈을 다시 풀었다
 * (운영에서 걸어 보고 확인). 관찰 테스트에서 보호자가 가장 먼저 지칠 자리다.
 *
 * ## 그래도 지키는 것
 * - **기기에 남기지 않는다** — 모듈 안의 숫자 하나다. 새로고침·탭을 닫으면 사라진다(무수집 · 아이가 나중에 혼자 못 연다).
 * - **3분** — 보호자가 둘러보고 돌아오는 동안만. 돌아올 때마다 다시 3분(둘러보는 중엔 안 끊긴다).
 * - 「아이 화면으로」를 누르면 **바로 잊는다** — 기기를 아이에게 넘기는 순간이다.
 */
const KEEP_MS = 3 * 60_000;
let passedAt = 0;

/** 지금 들어오면 바로 열어도 되나 */
export function familyPassFresh(now = Date.now()): boolean {
  return passedAt > 0 && now - passedAt < KEEP_MS;
}

/** 통과했다(또는 기억 안에 돌아왔다) — 지금부터 다시 3분 */
export function rememberFamilyPass(now = Date.now()): void {
  passedAt = now;
}

/** 아이에게 넘긴다 — 다음엔 다시 묻는다 */
export function forgetFamilyPass(): void {
  passedAt = 0;
}

export const FAMILY_PASS_KEEP_MS = KEEP_MS;
